import axios from "axios";
import authHeader from "./auth-header";
import { APP_URL } from "./http-common";

const URLEntityName = APP_URL + "oshma/shareholder";

async function deleteShareholding(id) {
  await axios
    .delete(URLEntityName + "/" + id, { headers: authHeader() })
    .then((response) => {
      if (
        response.status === 200 ||
        response.status === 201 ||
        response.status === 204
      ) {
        return response;
      }
      //return response;
    })
    .catch((err) => {
      return err;
    });
}

async function createShareholding(shareholding) {
  await axios
    .post(URLEntityName, shareholding, {
      headers: authHeader(),
    })
    .then((response) => {
      return response;
    });
}

async function updateShareholding(shareholding) {
  await axios
    .post(URLEntityName + "/" + shareholding.id, shareholding, {
      headers: authHeader(),
    })
    .then((response) => {
      return response;
    });
}
const shareholding = {
  createShareholding,
  deleteShareholding,
  updateShareholding,
};
export default shareholding;
